<template>
	<!--内容-->
	<div class="bodybox cursorstyle">
		<p>商标提价申请</p>
		<div>
			<div style="display: flex;">
				<div class="title">商标性质：</div>
        <div class="inputboxone">
          {{userObj.info().nature_txt}}
        </div>
			</div>

		</div>
		<div id="">
      <TrademarkPersonalEnter v-if="this.$route.query.create_type == 2"  :templat="this.nature" @dataNature="dataNature"></TrademarkPersonalEnter>

      <TrademarkPersonal v-else  :templat="this.nature" @dataNature="dataNature"></TrademarkPersonal>
		</div>
	</div>
</template>

<script>
	// 个人
	import TrademarkPersonal from './trademark/personalPage.vue'
	import TrademarkPersonalEnter from './trademark/personalPageEnter'
	export default {
		data() {
			return {
				nature:1,
			}
		},
		components: {
			TrademarkPersonal,
      TrademarkPersonalEnter
		},
		created() {
		},
		mounted() {
			// 1个人  ， 2内部
			this.nature = this.userObj.info().nature
			// this.nature = 2
		},
		methods: {
			dataNature(value){
				this.nature = value
			}
		}
	}
</script>

<style scoped="scoped" lang="less">
	.bodybox {
		width: 63vw;
		margin: 0 auto;
		/*border: 1px red solid;*/
		margin-top: 20px;
		/* border-left: 10px #fff solid; */
		color: #333333;
	}

	.bodybox>p {
		font-size: 18px;
		font-weight: bold;
		color: #333333;
		/* border: 1px red solid; */
		//width: 130px;
    //width: 8.4vw;
    //
    //text-align: right;
	}

	.bodybox>div {
		margin-top: 10px;
		display: flex;
		font-size: 14px;
	}

	.bodybox_first>div {
		margin-left: 20px;
	}

	.bodybox_first>div:first-child {
		margin-left: 10px;
	}

	.bodybox_first>div img {
		vertical-align: middle;
	}

	.bodybox>.PatentNature>div {
		line-height: 28px;
		margin-right: 20px;
	}

	.bodybox>.PatentNature>div>.inputbox {
		width: 164px;
		height: 28px;
		border-radius: 5px;
		border: 1px solid #E5E5E5;
		line-height: 28px;
		padding-left: 4px;
		color: #A0A0A0;
		font-size: 14px;
	}

	.bodybox>.applicant {
		line-height: 28px;
	}

	.bodybox>.applicant>.inputbox {
		width: 1095px;
		height: 28px;
		border-radius: 5px;
		border: 1px solid #E5E5E5;
		padding-left: 4px;
		color: #A0A0A0;
		font-size: 14px;
	}

	.bodybox>.business>div {
		display: flex;
	}

	.bodybox>.business>div>.bodybox_first {
		width: 507px;
		height: 326px;
		border-radius: 5px;
		border: 1px solid #E5E5E5;
	}

	.bodybox>.business>div>.bodybox_first {
		position: relative;

	}

	.bodybox>.business>div>.bodybox_first img {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);


	}

	.bodybox>.business>div:nth-child(2)>.title {
		//width: 62px;
		/* margin-left: 25px; */
	}

	.bodybox>.technology {
		line-height: 28px;
	}

	.bodybox>.technology>.inputbox {
		width: 164px;
		height: 28px;
		border-radius: 5px;
		border: 1px solid #E5E5E5;
		line-height: 28px;
		padding-left: 4px;
		color: #A0A0A0;
		font-size: 14px;
	}

	.bodybox>.technology>.enclosure {
		color: #7CBDF8;
		line-height: 28px;
		padding-left: 6px;
	}

	.bodybox>.technology>.enclosure img {
		vertical-align: middle;
	}

	.bodybox>.explain>.inputbox {
		width: 329px;
		height: 192px;
		background: #D8D8D8;
		border-radius: 5px;
	}

	.bodybox>.explain>.explainbox {
		width: 740px;
		height: 180px;
		border-radius: 5px;
		border: 1px solid #E5E5E5;
		margin-left: 10px;
		color: #E5E5E5;
		padding: 5px;
	}

	.bodybox>.tjbtn {
		width: 227px;
		height: 54px;
		background: #0D68BB;
		border-radius: 5px;
		margin: 0 auto;
		margin-top: 30px;
		color: #FFFFFF;
		font-size: 18px;
		line-height: 54px;
	}

	.bodybox>.tjbtn span {
		text-align: center;
		width: 227px;
	}

	.title {
		//width: 9vw;
		//text-align: right;

	}

	.inputboxone {
		width: 164px;
		height: 28px;
		border-radius: 5px;
		// border: 1px solid #E5E5E5;
		line-height: 28px;
		// padding-left: 4px;
		color: #A0A0A0;
		font-size: 14px;
		background: #E5E5E5;
	}

	.title {
		line-height: 28px;
	}
</style>
